module.exports = __webpack_public_path__ + "static/media/login-logo.aaca92d4.svg";